<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Fornecedores sugeridos
        </v-subheader>
        <v-divider/>
      <v-list dense class="rounded-card pt-0">
        <template v-for="(fornecedor, index) in aprovacao.fornecedores">
          <v-list-item dense :key="fornecedor.id">
            <v-list-item-content>
              <v-list-item-title>
                <px-span-tooltip
                  v-if="fornecedor.codigoInterno"
                  bottom
                  text-class="caption"
                  :text="`(${fornecedor.codigoInterno})`"
                  tooltip="Código interno do fornecedor"/>
                {{ fornecedor.pessoa.nome }}
                <px-popover-fornecedor :fornecedor="fornecedor" show-score />
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ fornecedor.pessoa.cnpj | cnpj }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="index !== (aprovacao.fornecedores.length - 1)"
                     :key="`v-div-f${fornecedor.id}`"/>
        </template>
      </v-list>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    mapFornecedores() {
      this.aprovacao.fornecedores = this.aprovacao.fornecedores.map(f => this.buildFornecedor(f));
    },
    buildFornecedor(fornecedor) {
      const detalheFornecedor = this.aprovacao.detalhesFornecedores
        .find(detalhe => detalhe.fornecedor.id === fornecedor.id);
      if (!detalheFornecedor) {
        return {
          ...fornecedor,
        };
      }
      return {
        ...fornecedor,
        codigoInterno: detalheFornecedor.codigoInterno,
      };
    },
  },
  created() {
    this.mapFornecedores();
  },
};
</script>
